import useOptionalWorkspace from '@features/Workspace/store/hooks/useOptionalWorkspace';
import { User, Workspace, useGetMeQuery } from '@app-types/blackroom-api';
import { PermissionKey } from '@app-types/blackroom-app';

function useAccount(): {
  isCurrentWorkspaceAdmin: boolean;
  isWorkspaceAdmin: (workspace: Pick<Workspace, 'id'>) => boolean;
  hasPermission: (permission: PermissionKey) => boolean;
  account?: User;
} {
  const currentWorkspace = useOptionalWorkspace();

  const { data: userData } = useGetMeQuery();
  const user = userData?.me as User;

  const isWorkspaceAdmin = (workspace: Pick<Workspace, 'id'>) =>
    user?.workspaceUsers.find((wu) => wu.workspace.id === workspace?.id)?.role
      .isAdmin === true;

  const isCurrentWorkspaceAdmin = currentWorkspace
    ? isWorkspaceAdmin(currentWorkspace)
    : false;

  const hasPermission = (permission: PermissionKey) => {
    if (!currentWorkspace) return false;
    return (
      user?.workspaceUsers.find((wu) => wu.workspace.id === currentWorkspace.id)
        ?.role.permissions[permission] === true
    );
  };

  return {
    account: user,
    isCurrentWorkspaceAdmin,
    isWorkspaceAdmin,
    hasPermission,
  };
}

export default useAccount;
